import { render, staticRenderFns } from "./RewardModule.vue?vue&type=template&id=ba53954a&scoped=true&"
import script from "./RewardModule.vue?vue&type=script&lang=js&"
export * from "./RewardModule.vue?vue&type=script&lang=js&"
import style0 from "./RewardModule.vue?vue&type=style&index=0&id=ba53954a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba53954a",
  null
  
)

export default component.exports